import { useHistory, useLocation } from "react-router";
import { DealDocumentsPopup, DealDocumentsPopupTab, DealDocumentsSecurity } from "./DealDocumentsPopup";
import { LocationState, LocationStateBuilder, PopupType } from "../../../types/state/ui/LocationState";
import { SubscriptionFeature } from "../../../types/billing/SubscriptionFeature";

export interface DealDocumentsPopupGlobalPayload {
    security: DealDocumentsSecurity
    requiredFeature: SubscriptionFeature | null
    defaultTab?: DealDocumentsPopupTab
}

export function DealDocumentsPopupGlobal() {
    const history = useHistory<LocationState>();
    const locationState = useLocation<LocationState<any, DealDocumentsPopupGlobalPayload>>().state;

    if (locationState?.popup?.type !== PopupType.DealDocuments || !locationState?.popup?.payload?.security) return null;

    const handleClose = () => {
        history.replace({
            ...history.location,
            state: new LocationStateBuilder(history.location.state).resetPopup().result()
        });
    }

    return (
        <DealDocumentsPopup
            security={locationState.popup.payload.security}
            onClose={handleClose}
            requiredFeature={locationState.popup.payload.requiredFeature}
            defaultTab={locationState.popup.payload.defaultTab}
        />
    );
}